module.exports = __webpack_public_path__ + "static/media/2.0db79998.webp";